import ZtSetTriggerAlarmModal from './zt-set-trigger-alarm-modal.vue'
export default ZtSetTriggerAlarmModal
